const middleware = {}

middleware['authenticated'] = require('../middleware/authenticated.ts')
middleware['authenticated'] = middleware['authenticated'].default || middleware['authenticated']

middleware['not-authenticated'] = require('../middleware/not-authenticated.ts')
middleware['not-authenticated'] = middleware['not-authenticated'].default || middleware['not-authenticated']

export default middleware
